import { useContext } from "react";
import { useParams } from "react-router";
import { ROUTE_PARAMS } from "@/constants";
import {
  CustomerRouteContext,
  type CustomerRouteContextValue,
} from "./CustomerRouteContext";

/**
 * The customer named by `:customerId`, or undefined outside a customer route.
 * Without a `CustomerRouteProvider` the segment is taken as the CDH id as-is.
 */
export const useRouteCustomer = (): CustomerRouteContextValue | undefined => {
  const context = useContext(CustomerRouteContext);
  const { [ROUTE_PARAMS.CUSTOMER_ID]: routeSegment } = useParams();

  if (context) {
    return context;
  }
  if (!routeSegment) {
    return undefined;
  }
  return { customerCdhId: routeSegment, customerRouteId: routeSegment };
};
